<template>
  <router-view />
</template>

<script>
import emitter, { setDeviceStatus } from "@/utils/eventBus";
import store from "@/storage/index.js"
import { classrooms } from "@/utils/userInfo.js";

let socket = null;

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0,
      lastSeenTimestamps: {},
      deviceStatuses: {},
    };
  },

  methods: {
    initWebSocket() {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }

      socket = new WebSocket(this.API_WS);

      socket.onopen = () => this.onOpenWS();
      socket.onmessage = (event) => this.onMessage(event);
      socket.onclose = () => this.onWSClose();
    },

    onOpenWS() {
        store.commit("setConnected", true);

      classrooms.forEach((classroom) => {
        const sendMsg = (token) => {
          const msg = JSON.stringify({
            deviceToken: token,
            state: true,
            data: true,
          });
          socket.send(msg);
        };

        sendMsg(classroom.token);
      });
    },

    onMessage(event) {
      try {
        const wsMessage = JSON.parse(event.data);
        const device = wsMessage.device.replace(/-/g, "");
        const now = Date.now();

        this.lastSeenTimestamps[device] = now;

        if (wsMessage.topic === "Data") {
          this.$set(this.deviceStatuses, device, true);
          emitter.emit("device-status", { device, isOnline: true });
          setDeviceStatus(device, true);
          emitter.emit("update-values", { wsMessage, device });
        }
      } catch (err) {}
    },

    onWSClose() {
      store.commit("setConnected", false);

      classrooms.forEach((classroom) => {
        const device = classroom.token.split("|")[0];
        emitter.emit("device-status", { device, isOnline: false });
        setDeviceStatus(device, false);
      });

      if (this.reconnect) {
        setTimeout(() => {
          this.reconnectAttempts++;
          this.initWebSocket();
        }, 5000);
      }
    },

    checkDeviceStatuses() {
      const now = Date.now();
      const timeout = 3000;

      classrooms.forEach((classroom) => {
        const device = classroom.token.split("|")[0].replace(/-/g, "");
        const lastSeen = this.lastSeenTimestamps[device];
        const isOnline = lastSeen && now - lastSeen < timeout;

        if (this.deviceStatuses[device] !== isOnline) {
          setDeviceStatus(device, isOnline);
          this.$set(this.deviceStatuses, device, isOnline);
          emitter.emit("device-status", { device, isOnline });
        }
      });
    },
  },

  mounted() {
    this.initWebSocket();

    this.deviceStatusInterval = setInterval(() => {
      this.checkDeviceStatuses();
    }, 1000);
  },

  beforeDestroy() {
    this.reconnect = false;
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    clearInterval(this.deviceStatusInterval);
    store.commit("setConnected", false);
  },
};
</script>
